<template>
  <a-card :bordered="false" title="佣金规则 / 添加佣金规则">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="baseItemLayout.labelCol"
      :wrapper-col="baseItemLayout.wrapperCol">
      <a-form-model-item label="规则名称" prop="ruleName">
        <a-input
          style="width:300px;"
          :maxLength="30"
          v-model="ruleForm.ruleName"
          placeholder="请输入规则名称"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="规则方式" required>
        <a-select v-model="ruleForm.ruleTypeId" :style="{width:(ruleForm.ruleTypeId===1?'150px':'300px')}"
                  @change="onChange">
          <a-select-option v-for="item in ruleTypeList" :key="item.ruleTypeId" :value="item.ruleTypeId">{{
              item.ruleTypeName
            }}
          </a-select-option>
        </a-select>
        <a-select v-model="ruleForm.childRuleTypeId" v-if="ruleForm.ruleTypeId===1"
                  :style="{width:(form.ruleTypeId===1?'140px':'200px')}"
                  @change="onChildChange"
                  style="margin-left:10px">
          <a-select-option v-for="item in childRuleTypeList" :key="item.ruleTypeId" :value="item.ruleTypeId">
            {{ item.ruleTypeName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <div v-if="ruleForm.ruleTypeId !== 7">
        <a-form-model-item label="佣金内容" prop="ruleValue">
          <a-input
            addonBefore="可分配总佣金的"
            addonAfter="%"
            :maxLength="5"
            v-model="ruleForm.ruleValue"
            style="width:300px;font-size:16px"
            placeholder="0-100"
          />
        </a-form-model-item>
      </div>
      <a-form-model-item label="优先级">
        <div class="in-b">{{ rulePriorityArr.rulePriorityName }}</div>
        <span class="red">(数字越小，优先级越高)</span>
      </a-form-model-item>
      <div v-if="ruleForm.ruleTypeId === 2">
        <a-form-model-item label="选择商品" prop="proRulesList">
          <a-button type="primary" @click="addPro">选择</a-button>
          <a-table style="width: 600px" :columns="columnsProTable" :dataSource="ruleForm.proRulesList" rowKey="dataId">
            <span slot="proName" slot-scope="index">
              <ellipsis :length="30" tooltip>{{ index }}</ellipsis>
            </span>
            <span slot="action" slot-scope="index">
              <a-button type="primary" size="small" @click="deleteProId(index)">移除</a-button>
            </span>
          </a-table>
        </a-form-model-item>
      </div>
      <div v-if="ruleForm.ruleTypeId === 7">
        <a-form-model-item label="指定商品" prop="proId">
          <a-button type="primary" @click="addPro">选择</a-button>
          <div v-if="ruleForm.proId">
            ID:{{ ruleForm.proId }},{{ ruleForm.proName }}
          </div>
        </a-form-model-item>
      </div>
      <div v-if="ruleForm.ruleTypeId === 1 && ruleForm.childRuleTypeId === 1">
        <a-form-model-item label="分销员" prop="staffNameList">
          <a-button type="primary" @click="onStaffVisible(1)">添加</a-button>
          <div>
            <template v-for="tagItem in ruleForm.staffNameList">
              <a-tag closable color="blue" @close="handleStaffClose(tagItem.dataId)" :key="tagItem.dataId">
                {{ tagItem.staffName }},{{ tagItem.staffMobile }}
              </a-tag>
            </template>
          </div>
        </a-form-model-item>
      </div>
      <div v-if="ruleForm.ruleTypeId === 1 && ruleForm.childRuleTypeId === 6">
        <a-form-model-item label="分销员分组" prop="staffGroupList">
          <a-button type="primary" @click="onStaffVisible(2)">添加</a-button>
          <div>
            <template v-for="tagItem in ruleForm.staffGroupList">
              <a-tag closable color="blue" @close="handleGroupClose(tagItem.dataId)" :key="tagItem.dataId">
                {{ tagItem.name }}
              </a-tag>
            </template>
          </div>
        </a-form-model-item>
      </div>
      <div v-if="ruleForm.ruleTypeId === 3">
        <a-form-model-item label="指定供应商" prop="supplierNoStr">
          <a-textarea style="width:300px;" :rows="6" placeholder="输入供应商编号，一行一个"
                      v-model="ruleForm.supplierNoStr"/>
        </a-form-model-item>
      </div>
      <div v-if="ruleForm.ruleTypeId === 4">
        <a-form-model-item label="指定商品品类" prop="selectCatalogList">
          <a-checkbox-group v-model="ruleForm.selectCatalogList">
            <a-checkbox
              style="margin: 0 15px 20px 0"
              v-for="item in proCatalogList"
              :key="item.dataId"
              :value="item.dataId"
            >
              {{ item.proCatalogName }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
      </div>
      <a-form-model-item :wrapper-col="formItemLayoutBtn.wrapperCol">
        <a-button type="primary" @click="submitForm">{{
            ruleForm.ruleTypeId === 7 ? '保存并下一步' : '保存'
          }}
        </a-button>
        <a-button v-if="ruleForm.ruleTypeId!==7" style="margin-left: 20px;" @click="goBack">取消</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-modal title="选择分销员" :footer="null" :width="650" :visible="staffVisible"
             @cancel="staffChange">
      <div>
        <a-form layout="inline">
          <a-form-item label="搜索名称">
            <a-input v-model="queryStaff.staffSearchInfo" placeholder="搜索手机号、真实姓名"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="$refs.tableStaff.refresh(true)">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
      <custom-page-table
        ref="tableStaff"
        :queryParams="queryStaff"
        :columns="columnsStaff"
        base-key="payUrl"
        params-path="commissionRule/getCommissionRuleMerchantStaffList"
      >
          <span slot="action" slot-scope="rowItem">
            <a-button type="primary" size="small" @click="selectStaffId(rowItem.record)">添加</a-button>
          </span>
      </custom-page-table>
    </a-modal>
    <a-modal title="选择分销员分组" :footer="null" :width="650" :visible="staffGroupVisible"
             @cancel="staffGroupVisible = false">
      <custom-page-table
        ref="tableGroup"
        :columns="columnsGroup"
        :requestPromise="getRequestPromiseGroup">
        >
        <span slot="action" slot-scope="rowItem">
            <a-button type="primary" size="small" @click="selectStaffGroup(rowItem.record)">添加</a-button>
          </span>
      </custom-page-table>
    </a-modal>
    <a-modal title="关联商品" :footer="null" :width="650" :visible="visiblePro" @cancel="visiblePro=false">
      <div style="margin-bottom: 20px;">
        <a-form layout="inline">
          <a-form-item label="商品ID">
            <a-input-number style="width: 160px;" v-model="queryPro.proId" :min="0" :precision="0"
                            placeholder="查询商品ID"/>
          </a-form-item>
          <a-form-item label="搜索名称">
            <a-input v-model="queryPro.proName" placeholder="查询商品名称"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="$refs.tablePro.refresh(true)">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
      <custom-page-table
        ref="tablePro"
        :queryParams="queryPro"
        :columns="columnsPro"
        base-key="payUrl"
        params-path="commissionRule/getCommissionRuleProductList"
      >
          <span slot="action" slot-scope="rowItem">
            <a-button type="primary" size="small" @click="selectProId(rowItem.record)">添加</a-button>
          </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
import formMixins from '../../../../utils/mixins/formMixins'

export default {
  name: 'AddCommissionRule',
  mixins: [formMixins],
  data() {
    return {
      columnsStaff: [
        {
          title: 'ID',
          dataIndex: 'dataId'
        },
        {
          title: '姓名',
          dataIndex: 'staffName'
        },
        {
          title: '手机号',
          dataIndex: 'staffMobile'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsPro: [
        {
          title: '商品ID',
          dataIndex: 'dataId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '300px'
        },
        {
          title: '商品类型',
          dataIndex: 'proCatalogStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsProTable: [
        {
          title: '商品ID',
          dataIndex: 'dataId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '150px',
          scopedSlots: { customRender: 'proName' }
        },
        {
          title: '商品类型',
          dataIndex: 'proCatalogStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsGroup: [
        {
          title: 'ID',
          dataIndex: 'dataId'
        },
        {
          title: '分组名称',
          dataIndex: 'name'
        },
        {
          title: '分组类型',
          dataIndex: 'catalogStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      rules: {
        'ruleName': [{ required: true, message: '请输入佣金规则名称', trigger: ['blur', 'change'] }],
        'staffNameList': [{ required: true, message: '请选择分销员', trigger: ['blur', 'change'] }],
        'staffGroupList': [{ required: true, message: '请选择分销员分组', trigger: ['blur', 'change'] }],
        'proRulesList': [{ required: true, message: '请选择商品', trigger: ['blur', 'change'] }],
        'supplierNoStr': [{ required: true, message: '请输入供应商', trigger: ['blur', 'change'] }],
        'selectCatalogList': [{ required: true, message: '请选择商品品类', trigger: ['blur', 'change'] }],
        'proId': [{ required: true, message: '请选择商品', trigger: ['blur', 'change'] }],
        'ruleValue': [
          { required: true, message: '请输入佣金比例', trigger: ['blur', 'change'] },
          {
            pattern: /^([0-9]\d?(\.\d{1,3})?|0\.\d{1,3}|100)$/,
            message: '请输入正确的比例',
            trigger: ['blur', 'change']
          }
        ]
      },
      ruleForm: {
        ruleValue: undefined,
        ruleTypeId: 1,
        childRuleTypeId: 1,
        ruleName: '',
        staffNameList: [],
        staffGroupList: [],
        proRulesList: [],
        selectCatalogList: [],
        proCatalog: '',
        proId: '',
        proName: '',
        supplierNoStr: ''
      },
      queryPro: {
        proId: '',
        proName: ''
      },
      ruleTypeList: [],
      childRuleTypeList: [],
      rulePriorityArr: {},
      staffGroupVisible: false,
      staffVisible: false,
      visiblePro: false,
      queryStaff: {
        staffSearchInfo: ''
      },
      ruleId: this.$route.query.id,
      dataList: []
    }
  },
  watch: {
    'ruleForm.ruleTypeId'(v) {
      this.ruleTypeList.forEach((val, key) => {
        if (v == 1) {
          val.childList.forEach((valC, keyC) => {
            if (this.ruleForm.childRuleTypeId == valC.ruleTypeId) {
              this.rulePriorityArr = {
                rulePriorityId: valC.rulePriorityId,
                rulePriorityName: valC.rulePriorityName
              }
            }
          })
        } else {
          if (v == val.ruleTypeId) {
            this.rulePriorityArr = {
              rulePriorityId: val.rulePriorityId,
              rulePriorityName: val.rulePriorityName
            }
          }
        }
      })
    },
    'ruleForm.childRuleTypeId'(v) {
      if (this.ruleForm.ruleTypeId == 1) {
        this.childRuleTypeList.forEach((val, key) => {
          if (v == val.ruleTypeId) {
            this.rulePriorityArr = {
              rulePriorityId: val.rulePriorityId,
              rulePriorityName: val.rulePriorityName
            }
          }
        })
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CommissionHelper', title: '佣金分配记录' },
      { name: 'CommissionRule', title: '佣金规则' }
    ])
    this.getBaseInfo()
    this.getCatalogList(this.$route.query.id)
    if (this.ruleId) {
      this.getCommissionRule(this.ruleId)
    }
  },
  methods: {
    //回显规则信息
    getCommissionRule(ruleId) {
      if (ruleId != 0) {
        this.getHttpServices()
          .getPayApiService()
          .post('commissionRule/getCommissionRule/' + ruleId)
          .then(res => {
            this.ruleForm.ruleName = res.ruleName
            this.ruleForm.ruleValue = res.ruleValue
            if (res.ruleType === 1) {  //按ruleType判断的时候目前写法是写死回显判断，后期如需修改得改成单选项下拉框
              this.ruleForm.ruleTypeId = 1
              this.ruleForm.childRuleTypeId = 1
              this.ruleForm.staffNameList = res.dataList
            } else if (res.ruleType === 6) {
              this.ruleForm.ruleTypeId = 1
              this.ruleForm.childRuleTypeId = 6
              this.ruleForm.staffGroupList = res.dataList
            } else if (res.ruleType === 2) {
              this.ruleForm.ruleTypeId = res.ruleType
              this.ruleForm.proRulesList = res.dataList
            } else if (res.ruleType === 3) {
              this.ruleForm.ruleTypeId = res.ruleType
              let arr = []
              res.dataList.map(item => {
                arr.push(item.dataId)
              })
              this.ruleForm.supplierNoStr = arr.join('\r\n')
            } else if (res.ruleType === 4) {
              this.ruleForm.ruleTypeId = res.ruleType
              let arr = []
              res.dataList.map(item => {
                if (item.flag) {
                  arr.push(item.dataId)
                }
              })
              this.ruleForm.selectCatalogList = arr
            } else if (res.ruleType === 5 || res.ruleType === 7) {
              this.ruleForm.ruleTypeId = res.ruleType
              this.ruleForm.proCatalog = res.dataList[0].proCatalog
              this.ruleForm.proId = res.dataList[0].dataId
              this.ruleForm.proName = res.dataList[0].proName
            }
            this.rulePriorityArr = {
              rulePriorityId: res.rulePriority,
              rulePriorityName: res.rulePriorityStr
            }
          })
          .catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.ruleForm.ruleId = 0 //佣金规则ID
        this.ruleForm.ruleName = '' //佣金规则名称
        this.ruleForm.ruleTypeId = 1
        this.ruleForm.childRuleTypeId = 1
      }
    },
    getCatalogList(ruleId) {
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/getCommissionRuleProCatalogList/' + ruleId)
        .then(res => {
          this.proCatalogList = res
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //移出商品
    deleteProId(index) {
      if (this.ruleForm.proRulesList.length > 0) {
        this.ruleForm.proRulesList.splice(index, 1)
      }
    },
    //保存
    submitForm(e) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.saveData()
        } else {
          this.getLogUtils().errorWithTag('error submit!!')
          return false
        }
      })
    },
    saveData() {
      let params = {
        ruleName: this.ruleForm.ruleName,
        rulePriority: this.rulePriorityArr.rulePriorityId,
        ruleValue: this.ruleForm.ruleValue
      }
      if (Number(this.ruleId) !== 0) {
        params.ruleId = this.ruleId
      }
      if (this.ruleForm.ruleTypeId === 1) {
        params.ruleType = this.ruleForm.childRuleTypeId
      } else {
        if (!this.ruleForm.ruleTypeId[0]) {
          params.ruleType = this.ruleForm.ruleTypeId
        } else {
          params.ruleType = this.ruleForm.ruleTypeId[0]
        }
      }
      //判断规则方式
      if (this.ruleForm.ruleTypeId === 1) {
        let arr = []
        if (this.ruleForm.childRuleTypeId === 1) {
          this.ruleForm.staffNameList.map(item => {
            arr.push(item.dataId)
          })
        } else {
          this.ruleForm.staffGroupList.map(item => {
            arr.push(item.dataId)
          })
        }
        params.dataList = arr
      } else if (this.ruleForm.ruleTypeId[0] === 2 || this.ruleForm.ruleTypeId === 2) {
        let arr = []
        this.ruleForm.proRulesList.map(item => {
          arr.push(item.dataId)
        })
        params.dataList = arr
      } else if (this.ruleForm.ruleTypeId[0] === 3 || this.ruleForm.ruleTypeId === 3) {
        let Str = this.ruleForm.supplierNoStr.split(/\r?\n/)
        params.dataList = Str
      } else if (this.ruleForm.ruleTypeId[0] === 4 || this.ruleForm.ruleTypeId === 4) {
        params.dataList = this.ruleForm.selectCatalogList
      } else if (this.ruleForm.ruleTypeId[0] === 5 || this.ruleForm.ruleTypeId === 5) {
        params.dataList = [2]
        params.rulePriority = 3
      } else if (this.ruleForm.ruleTypeId[0] === 7 || this.ruleForm.ruleTypeId === 7) {
        let arr = []
        params.proCatalog = this.ruleForm.proCatalog
        arr.push(this.ruleForm.proId)
        params.dataList = arr
      }
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/updateCommissionRule', params)
        .then(res => {
          if (this.ruleForm.ruleTypeId === 7) {
            this.goCalendar(res)
          } else {
            this.$message.success('保存成功')
            this.goBack()
          }
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          }
          this.getLogUtils().errorWithTag('err', err)
        })
    },
    goCalendar(id) {
      let query = {
        serverUniqueId: this.$route.query.serverUniqueId,
        serverId: this.$route.query.serverId,
        proId: this.ruleForm.proId,
        proName: this.ruleForm.proName,
        ruleId: id,
        proCatalog: this.ruleForm.proCatalog
      }
      this.openNewPage('CommissionCalendar', query)
    },
    //选择商品
    selectProId(obj) {
      if (this.ruleForm.ruleTypeId === 7) {
        this.ruleForm.proCatalog = obj.proCatalog
        this.ruleForm.proId = obj.dataId
        this.ruleForm.proName = obj.proName
        this.visiblePro = false
      } else {
        if (this.ruleForm.proRulesList.length < 5) {
          if (this.ruleForm.proRulesList.length > 0) {
            let flag = false
            this.ruleForm.proRulesList.map(item => {
              if (item.dataId == obj.dataId) {
                this.$message.error('请勿重复添加商品')
                flag = true
              }
            })
            if (!flag) {
              this.ruleForm.proRulesList.push(obj)
              this.visiblePro = false
            }
          } else {
            this.ruleForm.proRulesList.push(obj)
            this.visiblePro = false
          }
        } else {
          this.$message.error('最多添加5个商品')
        }
      }
    },
    addPro() {
      this.queryPro.ruleTypeId = this.ruleForm.ruleTypeId
      this.visiblePro = true
    },
    selectStaffId(obj) {
      if (this.ruleForm.staffNameList.length < 200) {
        if (this.ruleForm.staffNameList.length > 0) {
          let flag = false
          this.ruleForm.staffNameList.map(item => {
            if (item.dataId == obj.dataId) {
              this.$message.error('请勿重复添加分销员')
              flag = true
            }
          })
          if (!flag) {
            this.ruleForm.staffNameList.push(obj)
            this.staffVisible = false
          }
        } else {
          this.ruleForm.staffNameList.push(obj)
          this.staffVisible = false
        }
      } else {
        this.$message.error('最多添加200个分销员')
      }
    },
    //选择分销员---分组选择
    selectStaffGroup(obj) {
      if (this.ruleForm.staffGroupList.length < 10) {
        if (this.ruleForm.staffGroupList.length > 0) {
          let flag = false
          this.ruleForm.staffGroupList.map(item => {
            if (item.dataId == obj.dataId) {
              this.$message.error('请勿重复添加分销员')
              flag = true
            }
          })
          if (!flag) {
            this.ruleForm.staffGroupList.push(obj)
            this.staffGroupVisible = false
          }
        } else {
          this.ruleForm.staffGroupList.push(obj)
          this.staffGroupVisible = false
        }
      } else {
        this.$message.error('最多添加10个分销员')
      }
    },
    //删除分销员
    handleStaffClose(removedTag) {
      if (this.ruleForm.staffNameList.length > 0) {
        const tags = this.ruleForm.staffNameList.filter(tag => tag.dataId !== removedTag)
        //this.staffNameList.splice(index,1);
        this.ruleForm.staffNameList = tags
      }
    },
    //删除分销员---分组选择
    handleGroupClose(removedTag) {
      if (this.ruleForm.staffGroupList.length > 0) {
        const tags = this.ruleForm.staffGroupList.filter(tag => tag.dataId !== removedTag)
        this.ruleForm.staffGroupList = tags
      }
    },
    //获取优先级/
    staffChange() {
      this.staffVisible = false
    },
    onStaffVisible(num) {
      if (num == 1) {
        this.staffVisible = true
        this.$nextTick(() => {
          this.$refs.tableStaff.refresh(false)
        })
      } else {
        this.staffGroupVisible = true
        this.$nextTick(() => {
          this.$refs.tableGroup.refresh(false)
        })
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    onChange() {
      this.checkForm()
    },
    checkForm() {
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
          }
        })
      })
    },
    onChildChange(value) {
      this.checkForm()
    },
    getBaseInfo() {
      this.getHttpServices()
        .getPayApiService()
        .post('commissionRule/getBaseInfo')
        .then(res => {
          this.ruleTypeList = res
          this.childRuleTypeList = res[0].childList
          if (this.ruleForm.ruleTypeId === 1) {
            this.rulePriorityArr = {
              rulePriorityId: res[0].childList[0].rulePriorityId,
              rulePriorityName: res[0].childList[0].rulePriorityName
            }
            this.getLogUtils().logWithTag('rulePriorityArr', this.rulePriorityArr)
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getRequestPromiseGroup(params) {
      params.groupIdList = null
      params.ruleType = this.ruleForm.ruleTypeId
      return this.getHttpServices().getUserService().post('merchant/v2/group/getCommissionGroupList', params)
    }
  }
}
</script>

<style lang="less" scoped>
.red {
  margin-left: 10px;
  color: red;
}

.in-b {
  display: inline-block;
}
</style>